// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o3-1";
export var messageSideRight = "_o3-2";
export var orderLookupBubbleContainer = "_o3-0";
export var submitButton = "_o3-3";